import script from "./MoleculeDiagnostic.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeDiagnostic.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeDiagnostic.vue?vue&type=style&index=0&id=351fc0d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351fc0d0"]])

export default __exports__